import React from 'react'
import tw, { css } from 'twin.macro'

export const Hidden = React.forwardRef(function Hidden(props, ref) {
  return (
    <div tw="hidden">
      {ref}
    </div>
  )
})